// extracted by mini-css-extract-plugin
export default {"Container":"ReplyBadge_Container__0uyC5"};